export default {
    mounted() {
        this.draggedElement = null;
        this.draggedIndex = null;

        this.el.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: false });
        this.el.addEventListener("touchmove", this.handleTouchMove.bind(this), { passive: false });
        this.el.addEventListener("touchend", this.handleTouchEnd.bind(this), { passive: false });
    },

    destroyed() {
        this.el.removeEventListener("touchstart", this.handleTouchStart.bind(this));
        this.el.removeEventListener("touchmove", this.handleTouchMove.bind(this));
        this.el.removeEventListener("touchend", this.handleTouchEnd.bind(this));
    },

    handleTouchStart(e) {
        const handle = e.target.closest("[data-drag-handle]");
        if (!handle) return;

        e.preventDefault();

        const item = handle.closest("[data-section-id]");
        if (!item) return;

        this.draggedElement = item;
        this.draggedIndex = Array.from(this.el.children).indexOf(item);

        item.classList.add("opacity-50", "scale-95");
        item.style.transition = "all 0.2s ease";
    },

    handleTouchMove(e) {
        if (!this.draggedElement) return;

        e.preventDefault();

        const touch = e.touches[0];
        const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
        const targetItem = elementBelow?.closest("[data-section-id]");

        if (!targetItem || targetItem === this.draggedElement) return;

        const items = Array.from(this.el.children);
        const targetIndex = items.indexOf(targetItem);

        if (targetIndex === -1) return;

        if (targetIndex < this.draggedIndex) {
            targetItem.parentNode.insertBefore(this.draggedElement, targetItem);
        } else {
            targetItem.parentNode.insertBefore(this.draggedElement, targetItem.nextSibling);
        }

        this.draggedIndex = targetIndex;
    },

    handleTouchEnd(e) {
        if (!this.draggedElement) return;

        e.preventDefault();

        this.draggedElement.classList.remove("opacity-50", "scale-95");

        const items = Array.from(this.el.children);
        const sectionIds = items.map((item) => item.dataset.sectionId);

        const liveComponent = this.el.closest("[data-phx-component]");
        if (liveComponent) {
            this.pushEventTo(this.el, "reorder_sections", { section_ids: sectionIds });
        }

        this.draggedElement = null;
        this.draggedIndex = null;
    },
};
